import clsx from 'clsx'
import React from 'react'
import styles from './styles/Skeleton.module.scss'

type SkeletonProps = {
  height?: string
  width?: string
  className?: string
  variant?: 'button' | 'input' | 'text' | 'title' | 'circle' | 'line'
}

export const Skeleton: React.FC<SkeletonProps> = props => {
  const { height, width, className, variant } = props

  let style = {}

  if (height) {
    style = {
      ...style,
      '--height': height,
    }
  }

  if (width) {
    style = {
      ...style,
      '--width': width,
    }
  }

  return <span className={clsx(styles.skeleton, variant && styles[variant], className)} style={style} />
}
